import React from 'react';

export const NotFoundPage = () => {

    return <div className="notFoundPageContainer">
        <h1>Stránka neexistuje</h1>
    </div>
}